import { APP_INITIALIZER, ErrorHandler, Injector } from '@angular/core';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthService } from './_shared/services/auth.service';

import { RoutingService } from './_shared/services/routing.service';
import { SegmentService } from './_shared/services/segment.service';
import { RfHttpInterceptorInterceptor } from './_shared/rf-http-interceptor.interceptor';

import { environment } from '../environments/environment';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { ChunkLoadErrorHandler } from './_shared/services/chunk-load-error-handler';

export function rfInterceptorFactory(
    _authService: AuthService,
    _routingService: RoutingService,
    _segmentService: SegmentService,
    injector: Injector,
) {
    return new RfHttpInterceptorInterceptor(
        _authService,
        _routingService,
        _segmentService,
        injector,
    );
}

export const httpInterceptorProviders = [
    {
        provide: HTTP_INTERCEPTORS,
        useFactory: rfInterceptorFactory,
        deps: [AuthService, RoutingService, SegmentService, Injector],
        multi: true,
    },
];

export const sentryForProd = environment.production
    ? [
          {
              // Recovers from stale-deploy lazy-chunk load failures with a single
              // reload, and forwards every other error to Sentry (unchanged behaviour).
              // Fixes DOORSPOT-UI-D1, DOORSPOT-UI-D2, DOORSPOT-UI-D5.
              provide: ErrorHandler,
              useClass: ChunkLoadErrorHandler,
          },
          {
              provide: Sentry.TraceService,
              deps: [Router],
          },
          {
              provide: APP_INITIALIZER,
              useFactory: () => () => {},
              deps: [Sentry.TraceService],
              multi: true,
          },
      ]
    : [];
